<template>
  <div>
    <router-link
      class="btn btn-sm btn-success"
      :to="{ name: 'inventario-liquidacion-producto-nuevo', params: {} }"
    >
      <i class="fa fa-pencil"></i>
      Agregar Nueva Liquidación
    </router-link>
    <div
      aria-hidden="true"
      class="onboarding-modal modal fade animated"
      id="nuevaOrdenCompraModal"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-lg modal-centered" role="document">
        <div class="modal-content text-center">
          <button
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button"
          >
            <span class="close-label">Cancelar</span>
            <span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding">
            <div class="onboarding-content with-gradient">
              <div class="text-center">
                <h4 class="onboarding-title text-center">
                  Nueva Orden de Compra basada en una Cotización
                </h4>
              </div>
              <form>
                <div class="row">
                  <div class="col-md-12">
                    <OrdenCompraAddTableComponent />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import _ from "lodash";
import CommonService from "@/services/commons/CommonService";
import TiendaService from "@/services/catalogos/TiendaService";
import ProveedorService from "@/services/catalogos/ProveedorService";
import ProductosService from "@/services/catalogos/ProductosService";
import ReqCompraService from "@/services/compras/ReqCompraService";
import Notifications from "@/notifications/notifications";
import OrdenCompraAddTableComponent from "@/components/compras/ordencompra/OrdenCompraAddTableComponent";

export default {
  components: {
    OrdenCompraAddTableComponent,
  },
  data() {
    return {
      current: {
        id: null,
        tienda: "",
        fecha: "01/01/2019",
        estado: "A",
        errors: [],
        reqcomprad_set: [],
      },
      tiendas: [],
      proveedores: [],
      data: [],
      productos: [],
      options: [],
    };
  },
  computed: {
    ...mapGetters({
      getReqsComprasCotizar: "reqcompras/reqs_compras_cotizar",
    }),
  },
  mounted() {
    let self = this;
    TiendaService.fetch({
      activa: true,
      quitar_paginacion: true,
    }).then((res) => {
      self.tiendas = res.data;
    });
    CommonService.fecha_actual().then((res) => {
      self.current.fecha = res.data.fecha_actual;
    });
  },
  methods: {
    searchProveedor: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      ProveedorService.fetch({
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search,
      }).then((res) => {
        vm.proveedores = res.data;
        loading(false);
      });
    }, 350),
    onSearchProveedor(search, loading) {
      loading(true);
      this.search(loading, searchProveedor, this);
    },
    cargaRequerimientos(params) {
      let self = this;
      ReqCompraService.fetch({}).then((res) => {
        self.reqs = res.data;
      });
    },
    nuevaOrdenCompraModal() {
      let self = this;
      ProveedorService.fetch({
        page: 1,
      }).then((res) => {
        self.proveedores = res.data.results;
      });
      $("#nuevaOrdenCompraModal").modal("show");
      this.$store.dispatch("reqcompras/para_cotizar");
    },
  },
};
</script>
